export const STATUS = {
  PENDING_DOWNLOAD: 0, // 未下载
  PENDING_BIND: 1, // 未绑定
  BINDED: 2, // 已绑定
  UNAVAILABLE: 3, // 已失效
};

export const STATUS_LIST = [
  { label: "未下载", value: STATUS.PENDING_DOWNLOAD },
  { label: "未绑定", value: STATUS.PENDING_BIND },
  { label: "已绑定", value: STATUS.BINDED },
  { label: "已失效", value: STATUS.UNAVAILABLE },
];
